export default "__VITE_ASSET__CSB0SOsN__"